import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { LINKS } from "@/lib/site";

/* Subtle mobile-only sticky WhatsApp CTA, appears after the hero. */
export const MobileCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const contact = document.getElementById("contact");
      const nearContact =
        contact && contact.getBoundingClientRect().top < window.innerHeight * 0.9;
      setShow(y > window.innerHeight * 0.85 && !nearContact);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          data-testid="mobile-sticky-cta"
          href={LINKS.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="md:hidden fixed bottom-4 left-4 right-4 z-40 btn-primary shadow-lg"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        >
          <MessageCircle size={17} /> Chat on WhatsApp
        </motion.a>
      )}
    </AnimatePresence>
  );
};
